import { Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter, effect } from '@angular/core';
import { HelpersService } from '../../services/helpers/helpers.service';
import { Router, NavigationEnd, ActivatedRoute, NavigationStart } from '@angular/router';
import * as _ from 'lodash'
import * as moment from 'moment';
import { CalendarConfig } from './config';
import { NgIf, NgFor, NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AppStateService } from '../../services/helpers/app-state.service';

@Component({
    selector: 'app-ltms-daterange-picker',
    templateUrl: './ltms-daterange-picker.component.html',
    styleUrls: ['./ltms-daterange-picker.component.scss', './1366.scss'],
    imports: [NgIf, NgFor, NgClass, TranslateModule]
})
export class LtmsDaterangePickerComponent implements OnInit {
  @ViewChild('datepicker') datepicker!: ElementRef;
  @Input() mindays: number = 0;
  @Input() restricted: string = moment().subtract(this.mindays, 'day').format('YYYYMMDD')
  @Output() onDateRangeChange: any = new EventEmitter<any>();
  startDate: any = moment().startOf('month');
  endDate: any = moment().startOf('day');
 
  // acitve calendar date range
  calendarStartDate: any = moment(this.startDate);
  calendarEndDate: any = moment(this.endDate);

  formatedStartDate: string = this.startDate.format("DD MMM 'YY")
  formatedEndDate: string = this.endDate.format("DD MMM 'YY")

  currentDate = moment();
  defaultMinDays: number = 731;
  restrictedDate:any = null //moment().subtract(731, 'day').startOf('day');

  selectedDates: any = {
    start: {
      date: this.startDate.date(),
      year: this.startDate.year(),
      month: this.startDate.month(),
      timestamp: this.startDate.valueOf(),
      enabled: true
    },
    end: {
      date: this.endDate.date(),
      year: this.endDate.year(),
      month: this.endDate.month(),
      timestamp: this.endDate.valueOf(),
      enabled: true
    }
  }

  isRequestDate: boolean = true
  dayShortNames: any = ['S', 'M', 'T', 'W', 'T', 'F', 'S']
  monthNames: any = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  dateRangeTypes: any = [{
    label: "Today",
    type: "day",
    value: 1,
    active: false
  }, {
    label: "This Week",
    type: "week",
    value: 2,
    active: false
  }, {
    label: "This Month",
    type: "month",
    value: 3,
    active: true
  }, {
    label: "This Quarter",
    type: "quarter",
    value: 4,
    active: false
  }, {
    label: "This Year",
    type: "year",
    value: 5,
    active: false
  }, {
    label: "This Financial Year",
    type: "financial_year",
    value: 5,
    active: false
  }]

  activeRangeType: any = {
    label: "This Month",
    type: "month",
    value: 3,
    active: true
  }
  resetRangeType: any = {
    label: "This Month",
    type: "month",
    value: 3,
    active: true
  }
  calender: any = {
    previous: {},
    current: {}
  }

  disabledNextButton: boolean = false;
  disabledPrevButton: boolean = false;
  isCustomStartDateSelected: boolean = false;
  isCustomDateRangeSelected: boolean = false;
  isDateSelectorOpen: boolean = false;
  isStartDateSelected: boolean = false;
  isEndDateSelected: boolean = false;
  pickerButtons: any = {
    month: {
      next: false,
      previous: false
    },
    year: {
      next: false,
      previous: false
    }
  }

  appliedDateFilters: any = {
    formatedStartDate: this.startDate.format("DD MMM 'YY"),
    formatedEndDate: this.endDate.format("DD MMM 'YY"),
    startDate: this.startDate.format("YYYYMMDD"),
    endDate: this.endDate.format("YYYYMMDD"),
    isCustomDateRange: false,
    isPresetActive: true,
    isRequestDate: true,
    is_brand_creation_date_range: false
  }
  showDefaultCalender: boolean = true;
  showPresetsOnly: boolean = false;
  is_brand_creation_date_range: boolean = false;
  isAccount: boolean = false;
  datePickerConfig: any = Helpers.deepClone(CalendarConfig['default']);
  activeRoute: string = '';
  activeTab: string = '';
  maxDays: number = 731;
  accountId: string = ''
  projectId: string = ''
  executeDateRange: boolean = true;
  isPresetActive: boolean = true;
  isQuickPresetEnabled: boolean = false;
  isInitialDataInited: boolean = false;
  constructor(private _helpers: HelpersService, private _router: Router, private _route: ActivatedRoute, private _appStateService: AppStateService) {
    effect(() => {
      if (this._appStateService.initialized()) {
        this.isInitialDataInited = true;
        // console.log("AppState changed in component:", this._appStateService.appState());
      }
    });
   }

  ngOnInit(): void {
    this.isInitialDataInited = false;
    this.initDateRangePicker(true);
    // code is not requiered as of now we can un comment the code in future if required.
    // this._router.events.subscribe((event) => {
    //   // see also 
    //   if (event instanceof NavigationStart) {
    //     // console.log("NavigationStart", event, this._route.snapshot.queryParams)
    //   }
    //   if (event instanceof NavigationEnd) {
    //     console.log("NavigationEnd", event, this._route.snapshot.queryParams)
    //     let url = this._router.url;
    //     const routData = this.prepareRouteData(url)
    //     if (url == '/accounts') {
    //       this.reset()
    //     } else {
    //       this.updateDatePicker(routData)
    //     }
    //   }
    // });
    this.executeDateRange = true;
    this._route.queryParams.subscribe(params => {
      this._helpers.setPendingState(true);
      let url = this._router.url
      let activeTab = params['active_tab']
      let accountId = params['account_id'];
      let projectId = params['project_id']
      this.isAccount = (_.isNull(projectId) || !projectId) ? true : false;
      // let routeData = this.prepareRouteData(url)
      if(!params['active_tab'] || params['active_tab'] == ''){
        this.activeTab = '';
      }
      let routeData = this._helpers.prepareRouteData(url);
      if(this.isInitialDataInited && routeData.routeName != "relationship" && routeData.routeName != "settings"){
        this._appStateService.initialized.set(false);
      }
      if (url == '/accounts') {
        this.reset()
      } else {
        const projectRule = (accountId && projectId && (this.accountId != accountId || this.projectId != projectId || (activeTab && this.activeTab != activeTab) || (routeData.routeName && this.activeRoute != routeData.routeName))) ? true : false;
        const accountRule = (Helpers.isAccount && accountId && (this.accountId != accountId || (activeTab && this.activeTab != activeTab) || (routeData.routeName && this.activeRoute != routeData.routeName))) ? true : false;
        let isRouteChanged: boolean = false;
        let isActiveTabChanged: boolean = false;

        // if (this.activeRoute != routeData.routeName) {
        //   this.activeRoute = routeData.routeName;
        //   this.isRouteChanged = true;
        //   console.log("isRouteChanged",this.isRouteChanged)
        // }

        // if (this.activeTab != routeData.active_tab) {
        //   this.activeTab = routeData.active_tab;
        //   isActiveTabChanged = true
        // }

        let config = _.get(CalendarConfig, `${routeData.level}.${routeData.routeName}`);

        if (_.hasIn(CalendarConfig, `${routeData.level}.${routeData.routeName}.${routeData.active_tab}`)) {
          config = _.get(CalendarConfig, `${routeData.level}.${routeData.routeName}.${routeData.active_tab}`);
        }

        if (!_.isEmpty(config)) {
          this.datePickerConfig = Helpers.deepClone(config);
        }
        if (accountRule || projectRule) {

          if (this.activeRoute != routeData.routeName) {
            this.activeRoute = routeData.routeName;
            isRouteChanged = true;
          }

          if (this.activeTab != routeData.active_tab) {
            this.activeTab = routeData.active_tab;
            isActiveTabChanged = true
          }
          
          this.updateDatePicker(routeData,isRouteChanged,isActiveTabChanged)
        }
      }

    });
    this._helpers.appState.subscribe((state) => {
      if (state && _.hasIn(state, 'accountDetails._id') && _.get(state, 'accountDetails._id') != this.accountId && this.activeRoute == 'scores' && this.activeTab == 'trends') {
        this.accountId = _.get(state, 'accountDetails._id');
        this.datePickerConfig.showDatetypeToggler = _.get(state, 'accountDetails.enable_response_date_filter_in_score_tab', false)
      }
    })
  }

  ngOnChanges() {
    // this.initDateRangePicker(false);
  }

  ngOnDestroy() {
    // this.reset()
  }
  prepareRouteData(urlstr: string) {
    let url = urlstr.split('?')[0];
    let paramStr = urlstr.split('?')[1];
    let routeData: any = {}
    if (url != '') {
      const urlarr = url.split('/');
      routeData.url = urlstr
      routeData.level = urlarr[urlarr.length - 2];
      routeData.routeName = urlarr[urlarr.length - 1];
    }
    if (paramStr && paramStr != '') {
      let paramarray = paramStr.split("&")
      _.each(paramarray, (qyerystr: string) => {
        const arr = qyerystr.split("=")
        routeData[arr[0]] = arr[1]
      })
    }
    return routeData;
  }

  updateDatePicker(routeData: any,isRouteChanged:boolean,isActiveTabChanged:boolean) {

    let resetDateSelection: boolean = false;
    if (!this.datePickerConfig.hide) {
      this.dateRangeTypes = _.filter(this.dateRangeTypes, (rangeType: any) => {
        return rangeType.type != 'all';
      });


      if (this.isQuickPresetEnabled != this.datePickerConfig.showPreset) {
        resetDateSelection = true
      }

      if ((this.datePickerConfig.showPreset && (isRouteChanged || isActiveTabChanged)) || (routeData.level == 'project' && this.activeRangeType.type == 'all' && isRouteChanged)) {
        resetDateSelection = true
      }

      if ((this.accountId != routeData.account_id) || (this.projectId != routeData.project_id)) {
        this.projectId = routeData.project_id;
        this.accountId = routeData.account_id;
        resetDateSelection = true;
      }


      let applyFilter: boolean = false
      if (this.isRequestDate != this.datePickerConfig.isRequestDate && (this.datePickerConfig.showDatetypeToggler != true || isRouteChanged || isActiveTabChanged)) {
        this.isRequestDate = this.datePickerConfig.isRequestDate;

        applyFilter = true
      }

      if (Helpers && _.hasIn(Helpers, 'accountDetails._id') && _.hasIn(Helpers, 'accountDetails.enable_response_date_filter_in_score_tab') && this.activeRoute == 'scores' && this.activeTab == 'trends') {
        this.datePickerConfig.showDatetypeToggler = _.get(Helpers, 'accountDetails.enable_response_date_filter_in_score_tab', false)
      }

      if (routeData.routeName == 'action' || routeData.routeName == 'engagement') {
        this.maxDays = 366
      } else {
        this.maxDays = 731
      }
      const diff = Math.abs(moment(this.startDate).diff(this.endDate, 'days'))
      if (this.maxDays < diff && (isRouteChanged || isActiveTabChanged)) {
        resetDateSelection = true
      }


      if (this.datePickerConfig.addAllPreset) {
        this.dateRangeTypes.push({
          label: "All",
          type: "all",
          value: 5,
          active: false,
        })
      }

      if (this.datePickerConfig.showPreset) {
        this.initPresetDatePicker()
      } else if (resetDateSelection || this.executeDateRange) {
        this.isQuickPresetEnabled = false
        this.activeRangeType = {
          label: "This Month",
          type: "month",
          value: 3,
          active: true
        }
        this.startDate = moment().startOf('month');
        this.endDate = moment().startOf('day');
        this.apply()
        this.executeDateRange = false;
      } else {
        this.isQuickPresetEnabled = false
        if (applyFilter) {
          this.apply();
          applyFilter = false;
        }

        this._helpers.setPendingState(false);
        if(this.isInitialDataInited) {
          this._appStateService.initialized.set(true);
        }
      }
    }

  }




  initPresetDatePicker() {
    this.startDate = moment().subtract(1, 'weeks').startOf('week').add(1, 'day');
    this.endDate = moment(this.startDate).endOf('week').add(1, 'day').startOf('day')
    this.isCustomDateRangeSelected = false;
    this.isQuickPresetEnabled = true;
    this.activeRangeType = {
      label: "This Week",
      type: "week",
      value: 2,
      active: false
    }
    this.apply()
  }

  onQuickPresetChange(event: any, preset: string) {
    event.preventDefault();
    if (this.activeRangeType.type != preset) {
      if (preset == 'week') {
        this.startDate = moment().subtract(1, 'week').startOf('week').add(1, 'day');
        this.endDate = moment(this.startDate).endOf('week').add(1, 'day').startOf('day');
        this.activeRangeType = {
          label: "This Week",
          type: "week",
          value: 2,
          active: false
        }
      } else if (preset == 'month') {
        this.startDate = moment().subtract(1, 'month').startOf('month');
        this.endDate = moment(this.startDate).endOf('month').startOf('day');
        this.activeRangeType = {
          label: "This Month",
          type: "month",
          value: 3,
          active: true
        }
      } else if (preset == 'quarter') {
        this.startDate = moment().subtract(1, 'quarter').startOf('quarter');
        this.endDate = moment(this.startDate).endOf('quarter').startOf('day');
        this.activeRangeType = {
          label: "This Quarter",
          type: "quarter",
          value: 4,
          active: false
        }

      }
      this.apply();
    }

  }

  initDateRangePicker(resetCalender: boolean) {
    let diff = 0;
    if(this.restricted && moment(this.restricted).isValid()){
      this.restrictedDate = moment(this.restricted).startOf('day')
      // if (moment(this.restricted).isValid()) {
      //   diff = moment().diff(moment(this.restricted), 'day')
      // }
      // this.mindays = this.mindays || diff
      // if (this.mindays > 0 && this.mindays < this.defaultMinDays) {
      //   this.restrictedDate = moment().subtract(this.mindays, 'day').startOf('day');
      // } else if (diff > 0 && diff < this.defaultMinDays) {
      //   this.restrictedDate = moment(this.restricted)
      // } else {
      //   this.restrictedDate = moment().subtract(this.defaultMinDays, 'day').startOf('day');
      // }
    }
   
    if (!resetCalender) {
      const datePickerObject: any = this._helpers.getDatePickerValue();
      if (datePickerObject.startDate) {
        this.startDate = moment(datePickerObject.startDate, "YYYYMMDD");
        this.isStartDateSelected = true;
      }
      if (datePickerObject.endDate) {
        this.endDate = moment(datePickerObject.endDate, "YYYYMMDD");
        this.isEndDateSelected = true;
      }
    }

    this.checkRestrictedDates(this.startDate, this.endDate);
    this.setDateRange(this.startDate, true, false);
    this._helpers.datePicker.subscribe((datepicker: any) => {
      if (datepicker.startDate) {
        this.startDate = moment(datepicker.startDate, 'YYYYMMDD')
        this.appliedDateFilters.startDate = this.startDate.format("YYYYMMDD");
        this.appliedDateFilters.formatedStartDate = this.startDate.format("DD MMM 'YY");
        this.selectedDates.start = {
          date: this.startDate.date(),
          year: this.startDate.year(),
          month: this.startDate.month(),
          timestamp: this.startDate.valueOf(),
          enabled: true
        };
        this.isStartDateSelected = true;

      }
      if (datepicker.endDate) {
        this.endDate = moment(datepicker.endDate, 'YYYYMMDD');
        this.appliedDateFilters.endDate = this.endDate.format("YYYYMMDD");
        this.appliedDateFilters.formatedEndDate = this.endDate.format("DD MMM 'YY");
        this.selectedDates.end = {
          date: this.endDate.date(),
          year: this.endDate.year(),
          month: this.endDate.month(),
          timestamp: this.endDate.valueOf(),
          enabled: true
        };
        this.isEndDateSelected = true;
      }
      const trend = _.filter(this.dateRangeTypes, (range: any) => {
        return range.type == _.get(datepicker, 'trendType', 'month')
      })
      if (trend && trend.length) {
        this.activeRangeType = trend[0];
      }

      this.appliedDateFilters.isCustomDateRangeSelected = _.get(datepicker, 'isCustomDateRangeSelected', false);
      this.appliedDateFilters.isPresetActive = _.get(datepicker, 'isPresetActive', true);
      this.appliedDateFilters.isRequestDate = _.get(datepicker, 'isRequestDate', false);
      this.appliedDateFilters.dateFilterType = this.appliedDateFilters.isRequestDate ? 1 : 2;
      this.dateRangeTypes = _.map(this.dateRangeTypes, (rangeType: any) => {
        if (this.activeRangeType.type == rangeType.type && this.appliedDateFilters.isPresetActive) {
          rangeType.active = true;
        } else {
          rangeType.active = false;
        }
        return rangeType;
      })
    })
  }

  ngAfterViewInit() {
    document.addEventListener('click', (event) => {
      if (this.datepicker && this.datepicker.nativeElement !== event.target && !this.datepicker.nativeElement.contains(event.target)) {
        this.isDateSelectorOpen = false
      }
    });
  }

  toggleDateSelector(event: any) {
    event.preventDefault();
    this.isDateSelectorOpen = !this.isDateSelectorOpen;
    if (this.isDateSelectorOpen) {
      const checks = this.isRangeInActiveMonths(this.startDate, this.endDate, true);
      if (!checks.inRange) {
        this.setDateRange(this.startDate, checks.isAfter, checks.isBefore);
      }
    }
  }

  // apply date filters
  apply() {
    this.appliedDateFilters = {
      formatedStartDate: this.startDate.format("DD MMM 'YY"),
      formatedEndDate: this.endDate.format("DD MMM 'YY"),
      startDate: this.startDate.format("YYYYMMDD"),
      endDate: this.endDate.format("YYYYMMDD"),
      isCustomDateRangeSelected: this.isCustomDateRangeSelected,
      isPresetActive: this.isPresetActive,
      isRequestDate: this.isRequestDate,
      selectedTrend: this.activeRangeType.value,
      trendType: this.activeRangeType.type,
      dateFilterType: this.isRequestDate ? 1 : 2,
      is_brand_creation_date_range: this.is_brand_creation_date_range
    }
    this.isDateSelectorOpen = false
    this.onDateRangeChange.emit(this.appliedDateFilters)
    this._helpers.setDatePicker(this.appliedDateFilters)
    if(this.isInitialDataInited) {
      this._appStateService.initialized.set(true);
    }
  }
  // reset Date Filters
  reset() {
    this.startDate = moment().startOf('month')
    this.endDate = moment().startOf('day')
    this.activeRangeType = {
      label: "This Month",
      type: "month",
      value: 3,
      active: true
    }
    this.dateRangeTypes = _.map(this.dateRangeTypes, (rangeType: any) => {
      if (this.activeRangeType.type == rangeType.type) {
        rangeType.active = true;
      } else {
        rangeType.active = false;
      }
      return rangeType;
    })

    this.appliedDateFilters = {
      formatedStartDate: this.startDate.format("DD MMM 'YY"),
      formatedEndDate: this.endDate.format("DD MMM 'YY"),
      startDate: this.startDate.format("YYYYMMDD"),
      endDate: this.endDate.format("YYYYMMDD"),
      isCustomDateRangeSelected: false,
      selectedTrend: this.activeRangeType.value,
      isRequestDate: true,
      dateFilterType: 1,
      is_brand_creation_date_range: false
    }
    this.selectedDates = {
      start: {
        date: this.startDate.date(),
        year: this.startDate.year(),
        month: this.startDate.month(),
        timestamp: this.startDate.valueOf(),
        enabled: true
      },
      end: {
        date: this.endDate.date(),
        year: this.endDate.year(),
        month: this.endDate.month(),
        timestamp: this.endDate.valueOf(),
        enabled: true
      }
    }
    this.apply()
    // this.checkRestrictedDates(this.startDate, this.endDate);
    // this.setDateRange(this.startDate, true, false);
    // this.isDateSelectorOpen = false
    // this.onDateRangeChange.emit(this.appliedDateFilters)
    // this._helpers.setDatePicker(this.appliedDateFilters)
  }

  /**
   * Description: this function uses for set type of date like its respone date or request date
   * @param flag 
   */
  changeDateType(event: any, flag: boolean) {
    event.preventDefault();
    this.isRequestDate = flag
  }

  /**
   * Description: it's function which is used to set custom range by click on specific dates and it's called from html(UI)
   * @param date 
   */
  selectCustomDates(date: any) {
    const dateObject = moment(date.timestamp).startOf('day');
    if (!date.disabled) {
      if (!this.isCustomStartDateSelected) {
        this.isCustomStartDateSelected = true;
        this.selectedDates.start = {
          date: dateObject.date(),
          year: dateObject.year(),
          month: dateObject.month(),
          timestamp: dateObject.valueOf(),
          enabled: true
        };
        this.startDate = dateObject;
        this.selectedDates.end = {};
        this.isStartDateSelected = true;
        this.isEndDateSelected = false;
      } else {
        if (!this.isDateRangeExceeded(dateObject)) {
          this.isCustomStartDateSelected = false;
          this.isCustomDateRangeSelected = true;
          this.isPresetActive = false;
          if (moment(this.selectedDates.start.timestamp).isBefore(dateObject, 'day')) {
            this.endDate = dateObject
            this.selectedDates.end = {
              date: dateObject.date(),
              year: dateObject.year(),
              month: dateObject.month(),
              timestamp: dateObject.valueOf(),
              enabled: true
            };
          } else {
            this.selectedDates.end = this.selectedDates.start;
            this.endDate = this.startDate;
            this.startDate = dateObject;
            this.selectedDates.start = {
              date: dateObject.date(),
              year: dateObject.year(),
              month: dateObject.month(),
              timestamp: dateObject.valueOf(),
              enabled: true
            };
          }
          this.isEndDateSelected = true;
        }
      }
    }

    this.dateRangeTypes = _.map(this.dateRangeTypes, (rangeType: any) => {
      rangeType.active = false;
      return rangeType;
    });

  }

  /**
   * Description : This function change the range type and set the calendr active dates.its called from html(UI)
   * @param data : rangeType
   */
  changeRangeType(data: any) {
    this.isCustomStartDateSelected = false;
    this.isCustomDateRangeSelected = false;
    this.is_brand_creation_date_range = false;
    this.isPresetActive = true;
    this.activeRangeType = data
    this.dateRangeTypes = _.map(this.dateRangeTypes, (rangeType: any) => {
      rangeType.active = (rangeType.label == data.label) ? true : false;
      return rangeType;
    })
    let rangeType = data.type;
    if (rangeType == 'week') {
      rangeType = 'isoWeek'
    }
    let startDate = moment().startOf(rangeType);
    let endDate = moment(startDate).endOf(rangeType).startOf('day');

    if (data.type == "financial_year") {
      const currentQuarter = moment().quarter();
      if (currentQuarter > 1) {
        startDate = moment().quarter(2).startOf('quarter');
      } else {
        startDate = moment().subtract(1, 'years').quarter(2).startOf('quarter');
      }
      endDate = moment(startDate).add(1, 'year').quarter(1).endOf('quarter');

    }

    if (data.type == 'all' && this.datePickerConfig.addAllPreset) {
      startDate = moment(new Date(this.restrictedDate)).startOf('day')
      endDate = moment().startOf('day');
      this.is_brand_creation_date_range = true;
    }

    this.updateDateRangeView(startDate, endDate, false);

  }

  /**
   * Description: this function set the next date range depends on the date range type.
   * @param dateRangeType 
   */
  selectNextDateRange(dateRangeType: any) {
    this.isCustomDateRangeSelected = true
    this.isPresetActive = true
    let rangeType = dateRangeType.type;
    if (rangeType == 'week') {
      rangeType = 'isoWeek'
    }
    let startDate = moment(this.startDate).add(1, rangeType).startOf(rangeType);
    let endDate = moment(startDate).endOf(rangeType).startOf('day');

    if (dateRangeType.type == "financial_year") {
      startDate = moment(this.endDate).quarter(2).startOf('quarter');
      endDate = moment(startDate).add(1, 'year').quarter(1).endOf('quarter');
    }

    this.checkRestrictedDates(startDate, endDate);
    this.updateDateRangeView(startDate, endDate, true);;
  }

  /**
   *  Description: this function set the previous date range depends on the date range type.
   * @param dateRangeType 
   */
  selectPreviousDateRange(dateRangeType: any) {
    this.isCustomDateRangeSelected = true
    this.isPresetActive = true
    let rangeType = dateRangeType.type;
    if (rangeType == 'week') {
      rangeType = 'isoWeek'
    }
    let startDate = moment(this.endDate).subtract(1, rangeType).startOf(rangeType);
    let endDate = moment(startDate).endOf(rangeType).startOf('day');
    if (dateRangeType.type == "financial_year") {
      startDate = moment(this.startDate).subtract(1, 'year').quarter(2).startOf('quarter');
      endDate = moment(startDate).add(1, 'year').quarter(1).endOf('quarter');
    }
    const flag = (['financial_year', 'year', 'quarter'].includes(dateRangeType.type)) ? false : true;
    this.checkRestrictedDates(startDate, endDate);
    this.updateDateRangeView(startDate, endDate, false);
  }

  /**
   * Description: this function take start date and end date as arguments.then check below conditions
   *              this function is used to update the active calender dates.
   *              1) start date and end date date is in range of active calender
   *              2) start date is lesser then active calend start date
   *              3) end date is greater then active calender end date 
   * @param startDate 
   * @param endDate 
   * @returns {
   *  inRange:boolean,
   *  isAfter:boolean,
   * isBefore:boolean
   * }
   * 
   */
  isRangeInActiveMonths(startDate: any, endDate: any, isNextBtn: boolean): any {
    const isStartDateInRange = moment(startDate).isBetween(this.calendarStartDate, this.calendarEndDate, 'day');
    const isEndDateInRange = moment(endDate).isBetween(this.calendarStartDate, this.calendarEndDate, 'day');
    const isStartDateSameOrAFter = moment(startDate).isSameOrAfter(this.calendarStartDate, 'day');
    const isEndDateSameOrBefore = moment(endDate).isSameOrBefore(this.calendarEndDate, 'day');
    let inRange = ((isStartDateInRange && isEndDateInRange) || (isStartDateSameOrAFter && isEndDateSameOrBefore));
    let isBefore = moment(startDate).isBefore(this.calendarEndDate, 'day');
    let isAfter = moment(endDate).isAfter(moment(), 'day');
    const type = this.activeRangeType.type;
    let condition: any;
    switch (type) {
      case 'day':
        condition = (moment(startDate).isBefore(this.calendarStartDate, 'day'));
        isAfter = condition;
        isBefore = !condition;
        if (!isNextBtn && moment(startDate).isAfter(this.calendarEndDate, 'day')) {
          isAfter = true;
          isBefore = false;
        }
        break;
      case 'week':
        condition = (moment(startDate).isSameOrAfter(this.calendarEndDate, 'day')) || (moment(endDate).isSameOrAfter(this.calendarEndDate, 'day'));
        isAfter = isNextBtn ? !condition : condition;
        isBefore = isNextBtn ? condition : !condition;
        break;
      case 'month':
      case 'quarter':
      case 'year':
      case 'financial_year':
      default:
        condition = (moment(endDate).isSameOrAfter(moment(), 'day') && moment(startDate).isSameOrAfter(moment().startOf('month'), 'day'));
        isAfter = condition;
        isBefore = !condition;
        break;
    }
    return { inRange, isBefore, isAfter };
  }

  /**
   * Description: this function check start date and end date to block calend dates by using restricted date or current date.
   * 1) start date (in selected range) should not be less then restricted date
   * 2) end date (in selected range)  should not be greater then current date
   * 
   * @param startDate 
   * @param endDate 
   */
  checkRestrictedDates(startDate: any, endDate: any) {
    this.disabledPrevButton = (this.restrictedDate)?(moment(startDate).isSameOrBefore(this.restrictedDate, 'day')):false;
    this.disabledNextButton = (moment(endDate).isSameOrAfter(moment(), 'day'));
  }

  /**
   * Description: This function is used to control active calender date depend on range type like month or year
   * @param type 
   * @param isNext 
   */
  changeDatesRange(type: any, isNext: boolean) {
    const dateObject = isNext ? this.calendarEndDate : this.calendarStartDate;
    let startDate = isNext ? moment(dateObject).add(1, type) : moment(dateObject).subtract(1, type);

    // 1) if start date is after date of current date then set start to curernt  month
    // 2) if start date is before date of restricted date then set start to restricted date  month
    if (type == 'year' && moment(startDate).isAfter(moment().startOf('month'), 'month')) {
      startDate = moment().startOf('month')
    } else if (this.restrictedDate && type == 'year' && moment(startDate).isBefore(moment(this.restrictedDate).startOf('month'), 'month')) {
      startDate = moment(this.restrictedDate).startOf('month')
    }

    this.calendarStartDate = startDate.startOf('month');
    const condition = (moment(startDate).isAfter(this.calendarEndDate))
    this.setDateRange(this.calendarStartDate, isNext, !isNext);
  }

  /*
  *Description: This function update the view of calendar depending on selected range start date and end
  */
  updateDateRangeView(startDate: any, endDate: any, isNextBtn: boolean) {
    const newStartDate = (this.restrictedDate && moment(startDate).isSameOrBefore(this.restrictedDate, 'day')) ? this.restrictedDate : startDate;
    const newEndDate = (moment(endDate).isSameOrAfter(moment(), 'day')) ? moment().startOf('day') : endDate;
    this.selectedDates = {
      start: {
        date: newStartDate.date(),
        year: newStartDate.year(),
        month: newStartDate.month(),
        timestamp: newStartDate.valueOf(),
        enabled: true
      },
      end: {
        date: newEndDate.date(),
        year: newEndDate.year(),
        month: newEndDate.month(),
        timestamp: newEndDate.valueOf(),
        enabled: true
      }
    }
    this.startDate = newStartDate;
    this.endDate = newEndDate;
    this.formatedStartDate = newStartDate.format("DD MMM 'YY");
    this.formatedEndDate = newEndDate.format("DD MMM 'YY");
    this.checkRestrictedDates(startDate, endDate);
    const checks = this.isRangeInActiveMonths(newStartDate, newEndDate, isNextBtn);
    if (!checks.inRange) {
      this.setDateRange(newStartDate, checks.isAfter, checks.isBefore);
    }

    this.isStartDateSelected = true;
    this.isEndDateSelected = true;
  }

  /**
   * Description: this function is responsible for change the active calendar dates
   * @param startDate 
   * @param isNext 
   * @param isPrevious 
   */
  setDateRange(startDate: any, isNext: boolean, isPrevious: boolean) {
    // check restricted date so date selection not go beyond the restricted dates
    let dates: any = {
      current: {
        start: '',
        end: ''
      },
      previous: {
        start: '',
        end: ''
      }
    };
    // change the view of month in calendar
    if (isNext) {
      // right date picker
      dates.current.start = moment(startDate).startOf('month');
      dates.current.end = moment(startDate).endOf('month').startOf('day');
      // left date picker
      dates.previous.start = moment(startDate).subtract(1, 'month').startOf('month');
      dates.previous.end = moment(startDate).subtract(1, 'month').endOf('month').startOf('day');
    }
    if (isPrevious) {
      // right date picker
      dates.current.start = moment(startDate).add(1, 'month').startOf('month');
      dates.current.end = moment(startDate).add(1, 'month').endOf('month').startOf('day');
      // left date picker
      dates.previous.start = moment(startDate).startOf('month');
      dates.previous.end = moment(startDate).endOf('month').startOf('day');
    }

    this.calender.previous = this.getMonthDetails(dates.previous.start, dates.previous.end);
    this.calender.current = this.getMonthDetails(dates.current.start, dates.current.end);
    // set visiblity of presets buttons depending on restricted dates.
    this.setCalendarDatesAndPresetsBtn(this.calender);
  }

  /**
   *  Description: this function is used to controll the presets buttons visiblity and setting the active calender dates
   * @param activeDateRange 
   */
  setCalendarDatesAndPresetsBtn(activeDateRange: any) {
    const currentDates = _.filter(_.flattenDeep(activeDateRange.current.days), { enabled: true });
    const prevDates = _.filter(_.flattenDeep(activeDateRange.previous.days), { enabled: true });
    const startOfCalender: any = _.maxBy(prevDates, 'date');
    const endOfCalender: any = _.minBy(currentDates, 'date');
    // set calendar start and end date means active date range.
    this.calendarStartDate = moment(startOfCalender.timestamp).startOf('month');
    this.calendarEndDate = moment(endOfCalender.timestamp).endOf('month').startOf('day');
    // here we are set the visiblity of presets buttons
    this.pickerButtons = {
      month: {
        next: (moment(endOfCalender.timestamp).isSameOrAfter(moment(), 'month')),
        previous: (this.restrictedDate && moment(startOfCalender.timestamp).isSameOrBefore(this.restrictedDate, 'month'))
      },
      year: {
        next: (moment(endOfCalender.timestamp).isSameOrAfter(moment(), 'year')),
        previous: (this.restrictedDate && moment(startOfCalender.timestamp).isSameOrBefore(this.restrictedDate, 'year'))
      }
    };
  }

  // Selected Range style functions start
  /**
   * Description: below function is used to controll the selected range visualisation
   */
  isStartDate(date: any) {
    if (date.timestamp == this.selectedDates.start.timestamp && date.enabled) {
      return true;
    } else {
      return false;
    }
  }

  isEndDate(date: any) {
    if (date.timestamp == this.selectedDates.end.timestamp && date.enabled) {
      return true;
    } else {
      return false;
    }
  }

  isDateInRange(date: any) {
    if (date.timestamp > this.selectedDates.start.timestamp && date.timestamp < this.selectedDates.end.timestamp && date.enabled) {
      return true;
    } else {
      return false;
    }
  }

  isStartOfMonth(date: any) {
    const startOfMonth = moment(date.timestamp).startOf('month').valueOf();
    const startOfWeek = moment(date.timestamp).startOf('week').valueOf();
    if (date.timestamp == startOfWeek && date.enabled) {
      return true;
    } else if (date.timestamp == startOfMonth && date.enabled) {
      return true;
    } else {
      return false;
    }
  }

  isEndOfMonth(date: any) {
    const endOfMonth = moment(date.timestamp).endOf('month').startOf('day').valueOf();
    const endOfWeek = moment(date.timestamp).endOf('week').startOf('day').valueOf();
    if (date.timestamp == endOfWeek && date.enabled) {
      return true;
    } else if (date.timestamp == endOfMonth && date.enabled) {
      return true;
    } else {
      return false;
    }
  }
  // Selected Range style functions end

  /**
   * Description: function used to calculate the date range for a single month to view in date picker calendar.its return a month object
   * @param startDate 
   * @param endDate 
   * @returns objet of month
   */
  private getMonthDetails(startDate: any, endDate: any) {
    let daysList: any = [];
    let flag = true;
    const firstDay = startDate.date;
    const lastDayOfMonth = endDate.get('date');

    // create date range for active monthes like 1 to 30 its depend on end date of month
    var days: any = [...Array(lastDayOfMonth).keys()].map((day) => {
      const dateObject = moment(startDate).add(day, 'days');
      return {
        date: dateObject.date(),
        year: dateObject.year(),
        month: dateObject.month(),
        timestamp: dateObject.valueOf(),
        disabled: (moment(dateObject).isAfter(moment(), 'day') || (this.restrictedDate && moment(dateObject).isBefore(this.restrictedDate, 'day'))),
        enabled: true
      }
    })
    // add previous month date on if start date is not equal to start date of week
    if (startDate.day() != 0) {
      days = this.addPriviousMonthDate(startDate, firstDay, days);
    }

    days = this.addNextMonthDate(startDate, days);
    // grouping the days by weeks
    while (flag) {
      daysList.push(days.splice(0, 7));
      if (days.length <= 0) {
        flag = false;
      }
    }
    return {
      days: daysList,
      year: startDate.year(),
      month: startDate.month(),
      monthName: this.monthNames[startDate.month()],
      currentDate: new Date().getDate()
    };
  }

  // Helper Function for getMonthDetails it will used for complete the first week days
  private addPriviousMonthDate(date: any, firstDay: number, days: any) {
    // get start date of previous week.
    const startOfWeek = moment(date).subtract(1, 'month').endOf('month').startOf('week');
    const startDate: number = startOfWeek.get('date');
    const endDate: number = moment(date).subtract(1, 'month').endOf('month').get('date');
    // push previos month date in days array of active month to complete the first week
    for (var i = startDate; i <= endDate; i++) {
      const dateObject = moment(startOfWeek).date(i);
      days.splice(0, 0, {
        date: dateObject.date(),
        year: dateObject.year(),
        month: dateObject.month(),
        timestamp: dateObject.valueOf(),
        disabled: (moment(dateObject).isAfter(moment(), 'day') || (this.restrictedDate && moment(dateObject).isBefore(this.restrictedDate, 'day'))),
        enabled: false
      });
    }
    return days;
  }

  // Helper Function for getMonthDetails it will used for complete the end week days
  private addNextMonthDate(date: any, days: any) {
    let firstDay = moment(date).add(1, 'month').startOf('month');
    // push first day of next month in days array for active month till total days reached to 42
    days.push({
      date: firstDay.date(),
      year: firstDay.year(),
      month: firstDay.month(),
      timestamp: firstDay.valueOf(),
      disabled: (moment(firstDay).isAfter(moment(), 'day') || (this.restrictedDate && moment(firstDay).isBefore(this.restrictedDate, 'day'))),
      enabled: false
    });
    // push next month dates  in days array for active month till total days reached to 42
    for (var day = days.length; day < 42; day++) {
      const dateObject = moment(firstDay).add(1, 'day');
      days.push({
        date: dateObject.date(),
        year: dateObject.year(),
        month: dateObject.month(),
        timestamp: dateObject.valueOf(),
        disabled: (moment(dateObject).isAfter(moment(), 'day') || (this.restrictedDate && moment(dateObject).isBefore(this.restrictedDate, 'day'))),
        enabled: false
      });
    }
    return days;
  }
  isDateRangeExceeded(date: any) {
    const dateDiff = Math.abs(this.startDate.diff(date, 'days'))
    return (dateDiff > this.maxDays)
  }
  isAllowedDateRange(event: any, date: any) {
    const dateObject = moment(date.timestamp).startOf('day');

    if (this.startDate && this.isCustomStartDateSelected && this.isDateRangeExceeded(dateObject)) {
      event.target.classList.add('not-allowed')
    }
  }
  clearAllowedDateRange(event: any) {
    event.target.classList.remove('not-allowed')
  }
}